import styled from 'styled-components';

export const MvpDesignBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 8px 16px 16px 16px;
`;

export const MvpDesignMessageContainer = styled.span`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 90%;
  margin: 0 auto 8px auto;
  color: rgba(23, 42, 66, 0.65);
`;

export const MvpDesignContentContainer = styled.span`
  display: flex;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 100%;
  margin: 0 auto 24px auto;
  color: rgba(23, 42, 66, 0.65);
  white-space: pre-line;
`;
